<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;" label="邮件地址：">
        <el-input v-model="dataForm.address" placeholder="邮件地址" clearable></el-input>
      </el-form-item>
      <el-form-item style="float: left;" label="发送类型：">
        <template>
          <el-select v-model="dataForm.type" clearable placeholder="请选择">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item style="float: left;" label="发送状态：">
        <template>
          <el-select v-model="dataForm.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button @click="addOrUpdateHandle()" type="primary" >新增</el-button>
        <el-button type="success" @click="smsExcel()">导出Excel</el-button>
        <el-button type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">批量删除</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 120px)"
      border stripe :header-cell-style="{background:'#FAFAFA'}" placement="top">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="address"
        header-align="center"
        align="center"
        label="邮件地址">
      </el-table-column>
      <el-table-column
        prop="content"
        header-align="center"
        align="center"
        label="邮件内容" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="subject"
        header-align="center"
        align="center"
        label="邮件主题" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="typeName"
        header-align="center"
        align="center"
        label="发送类型">
      </el-table-column>
      <el-table-column
        prop="statusName"
        header-align="center"
        align="center"
        label="发送状态">
        <template slot-scope="scope">
          <label v-if="scope.row.status == '1'">
            <i
              style="display: inline-block;width: 12px;height: 12px;border-radius: 10px;background: #534646;margin: 0 4px;"></i>{{
              scope.row.statusName
            }}
          </label>
          <label v-if="scope.row.status == '2'">
            <i
              style="display: inline-block;width: 12px;height: 12px;border-radius: 10px;background: #00d67e;margin: 0 4px;"></i>{{
              scope.row.statusName
            }}
          </label>
          <label v-if="scope.row.status == '3'">
            <i
              style="display: inline-block;width: 12px;height: 12px;border-radius: 10px;background: #bf6464;margin: 0 4px;"></i>{{
              scope.row.statusName
            }}
          </label>
        </template>
      </el-table-column>
      <el-table-column
        prop="responseCode"
        header-align="center"
        align="center"
        label="返回码" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="创建时间">
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        width="150"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)"><i class="el-icon-edit-outline"
                                                                                          style="font-size: 18px;"></i>
          </el-button>
          <el-button type="text" size="small" @click="deleteHandle(scope.row.id)"><i class="el-icon-delete"
                                                                                     style="font-size: 18px;"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './mail-add-or-update'
import {excel} from "@/utils";

export default {
  data() {
    return {
      dataForm: {
        key: ''
      },
      dataList: [],
      typeOptions: [],
      statusOptions: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getDataList()
    this.getTypeOption()
    this.getStatusOption()
  },
  methods: {
    search(){
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/mail/list'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'address': this.dataForm.address,
          'status': this.dataForm.status,
          'type': this.dataForm.type,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/mail/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //excel
    smsExcel() {
      excel("/mail/excel", "邮件信息-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'address': this.dataForm.address,
        'status': this.dataForm.status,
        'type': this.dataForm.type,
      })
    },
    //获取类型
    getTypeOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/12"),
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.typeOptions = data.data.enumOption
        }
      })
    },
    //获取状态
    getStatusOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/8"),
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.statusOptions = data.data.enumOption
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/backstagefunction/mail.vue